import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  updateFarmContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.app.spacing.sm
  },

  checkInputContainer: {
    display: 'flex',
    gap: '40px',
    marginBottom: '16px',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '10px'
    }
  },

  updateFarmButton: {
    marginTop: 21,
    width: 112
  },

  updateFarmButtonCancel: {
    marginTop: 21,
    width: 112,
    backgroundColor: theme.app.colors.text.light,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`
  },

  updateFarmInput: {
    width: '100%'
  },

  cityUfContainer: {
    display: 'flex',
    gap: theme.app.spacing.base,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0
    }
  },

  updateFarmInputCityUf: {
    flex: 1
  },

  updateFarmButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 0 0 16px'
    }
  }
}))
